import { Badge } from '@src/design-system/badge';
import { cn } from '@src/design-system/helpers';
import type { TAnnouncementStatus } from '@src/shared/types/announcement';
import { resolveAnnouncementStatus } from '../utils/announcement-status';
import type { TAnnouncement } from '@src/shared/types/announcement';

const STATUS_STYLES: Record<
  TAnnouncementStatus,
  { label: string; className: string; showDot?: boolean }
> = {
  LIVE: {
    label: 'Live',
    className: 'bg-green-50 text-green-500',
    showDot: true,
  },
  SCHEDULED: {
    label: 'Scheduled',
    className: 'bg-secondary-100 text-secondary-1000',
  },
  INACTIVE: {
    label: 'Inactive',
    className: 'bg-gray-100 text-gray-600',
  },
  EXPIRED: {
    label: 'Expired',
    className: 'bg-red-100 text-red-500',
  },
};

type AnnouncementStatusBadgeProps = {
  announcement: Pick<
    TAnnouncement,
    'status' | 'is_active' | 'share_at' | 'expire_at'
  >;
};

export function AnnouncementStatusBadge({
  announcement,
}: AnnouncementStatusBadgeProps) {
  const status = resolveAnnouncementStatus(announcement);
  const config = STATUS_STYLES[status];

  return (
    <Badge
      className={cn(
        'inline-flex h-8 items-center gap-1 rounded-full border-none px-3 py-1.5 text-sm font-normal',
        config.className
      )}
    >
      {config.showDot ? (
        <span className='size-1.5 shrink-0 rounded-full bg-current' />
      ) : null}
      {config.label}
    </Badge>
  );
}
